import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/CustomBox/config';
import { ExternalReactRenderers } from '../../../Editor/types';
import cn from 'classnames';
import { Measureable } from '../../types';

import s from './CustomBox.scss';

export interface Props extends Measureable {
  contentJson: any;
  className?: string;
  externalRenderers: ExternalReactRenderers;
}

const CustomBoxViewer = React.forwardRef<HTMLDivElement, Props>(
  (
    { contentJson, className, externalRenderers, cookieType, defaultSize },
    ref
  ) => {
    return (
      <Viewer
        presetId="custombox"
        contentJson={contentJson}
        className={cn(s['root'], className)}
        extensionConfig={extConfig}
        externalRenderers={externalRenderers}
        cookieType={cookieType}
        defaultSize={defaultSize}
        ref={ref}
      />
    );
  }
);
CustomBoxViewer.displayName = 'CustomBoxViewer';

export default CustomBoxViewer;
